// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* C64 Arcade - Main Styles */

/* CSS Variables for C64 Color Palette */
:root {
  --c64-black: #000000;
  --c64-white: #FFFFFF;
  --c64-red: #883932;
  --c64-cyan: #67B6BD;
  --c64-purple: #8B3F96;
  --c64-green: #55A049;
  --c64-blue: #40318D;
  --c64-yellow: #BFCE72;
  --c64-orange: #8B5429;
  --c64-brown: #574200;
  --c64-light-red: #B86962;
  --c64-dark-grey: #505050;
  --c64-medium-grey: #787878;
  --c64-light-green: #94E089;
  --c64-light-blue: #7869C4;
  --c64-light-grey: #9F9F9F;
}

/* Global Reset and Base Styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  height: 100%;
  font-family: 'Courier New', monospace;
  background-color: var(--c64-blue);
  color: var(--c64-white);
  overflow: hidden;
  user-select: none;
  -webkit-user-select: none;
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: transparent;
}

#app {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
}

/* Pixel Art Font */
.pixel-font {
  font-family: 'Courier New', monospace;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: -webkit-crisp-edges;
  image-rendering: -moz-crisp-edges;
  image-rendering: -o-crisp-edges;
  image-rendering: pixelated;
}

/* Main Game Canvas */
#gameCanvas {
  display: block;
  margin: 0 auto;
  background-color: var(--c64-black);
  border: 2px solid var(--c64-white);
  image-rendering: -webkit-optimize-contrast;
  image-rendering: -webkit-crisp-edges;
  image-rendering: -moz-crisp-edges;
  image-rendering: -o-crisp-edges;
  image-rendering: pixelated;
  touch-action: none; /* Prevent all default touch behaviors */
  max-width: 100vw;
  max-height: 100vh;
  -webkit-user-select: none;
  user-select: none;
}

/* UI Container */
.ui-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 10;
}

.ui-container > * {
  pointer-events: auto;
}

/* Main Menu Styles */
.main-menu {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 20px;
}

.logo {
  font-size: 48px;
  font-weight: bold;
  color: var(--c64-cyan);
  text-align: center;
  margin-bottom: 40px;
  line-height: 1;
  text-shadow: 2px 2px 0px var(--c64-blue);
}

.game-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  max-width: 900px;
  width: 100%;
  margin-bottom: 30px;
}

.game-card {
  background: var(--c64-black);
  border: 3px solid var(--c64-white);
  padding: 15px;
  text-align: center;
  cursor: pointer;
  transition: all 0.1s;
  min-height: 140px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.game-card:hover {
  background: var(--c64-white);
  color: var(--c64-black);
  border-color: var(--c64-cyan);
}

.game-card:active {
  transform: scale(0.95);
}

.game-title {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 10px;
}

.game-preview {
  height: 60px;
  background: var(--c64-blue);
  border: 1px solid var(--c64-medium-grey);
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
}

.game-highscore {
  font-size: 12px;
  color: var(--c64-yellow);
}

.menu-buttons {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: center;
}

.menu-button {
  background: var(--c64-green);
  color: var(--c64-white);
  border: 2px solid var(--c64-white);
  padding: 10px 20px;
  font-family: inherit;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.1s;
  min-width: 120px;
}

.menu-button:hover {
  background: var(--c64-light-green);
  color: var(--c64-black);
}

.menu-button:active {
  transform: scale(0.95);
}

/* Game HUD */
.game-hud {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 40px;
  background: var(--c64-black);
  border-bottom: 2px solid var(--c64-white);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  font-size: 14px;
  z-index: 20;
}

.hud-left, .hud-right {
  display: flex;
  gap: 20px;
}

.hud-center {
  font-weight: bold;
  color: var(--c64-yellow);
}

/* Mobile Controls */
.mobile-controls {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 120px;
  background: rgba(0, 0, 0, 0.8);
  display: none;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  z-index: 30;
}

.virtual-dpad {
  width: 80px;
  height: 80px;
  position: relative;
  background: var(--c64-dark-grey);
  border: 2px solid var(--c64-white);
  border-radius: 50%;
}

.dpad-button {
  position: absolute;
  background: var(--c64-medium-grey);
  border: 1px solid var(--c64-white);
  color: var(--c64-white);
  font-weight: bold;
  cursor: pointer;
  user-select: none;
}

.dpad-up {
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 24px;
  height: 24px;
  line-height: 22px;
  text-align: center;
}

.dpad-down {
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 24px;
  height: 24px;
  line-height: 22px;
  text-align: center;
}

.dpad-left {
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  line-height: 22px;
  text-align: center;
}

.dpad-right {
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  line-height: 22px;
  text-align: center;
}

.action-buttons {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.action-button {
  width: 60px;
  height: 30px;
  background: var(--c64-red);
  color: var(--c64-white);
  border: 2px solid var(--c64-white);
  font-family: inherit;
  font-size: 12px;
  cursor: pointer;
}

.action-button:active {
  background: var(--c64-light-red);
}

/* Responsive Design */
@media (max-width: 768px) {
  body {
    -webkit-text-size-adjust: none; /* Prevent text scaling on iOS */
  }

  #app {
    width: 100vw;
    height: 100vh;
    overflow: hidden;
  }

  .main-menu {
    padding: 15px;
    height: 100vh;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */
  }

  .logo {
    font-size: 36px;
    margin-bottom: 30px;
    padding: 10px 0;
  }

  .game-grid {
    grid-template-columns: 1fr;
    gap: 15px;
    padding: 0;
    max-width: 100%;
    margin-bottom: 20px;
  }

  .game-card {
    min-height: 120px;
    padding: 20px;
    border-width: 3px;
  }

  .game-title {
    font-size: 16px;
    margin-bottom: 12px;
  }

  .game-preview {
    height: 50px;
    font-size: 24px;
    margin-bottom: 12px;
  }

  .game-highscore {
    font-size: 13px;
  }

  .menu-buttons {
    gap: 15px;
    padding: 15px 0;
  }

  .menu-button {
    min-width: 140px;
    padding: 16px 24px;
    font-size: 16px;
    min-height: 56px; /* Larger touch target */
  }

  .mobile-controls {
    display: flex;
  }

  /* Improve canvas positioning on mobile */
  #gameCanvas {
    border: none !important; /* Remove border on mobile for maximum screen usage */
    margin: 0 !important;
    touch-action: none; /* Prevent default touch behaviors */
    position: fixed !important; /* Ensure it stays in place */
    z-index: 1;
    max-width: none !important;
    max-height: none !important;
  }
}

@media (max-width: 480px) {
  .main-menu {
    padding: 10px;
  }

  .logo {
    font-size: 32px;
    margin-bottom: 25px;
  }

  .game-grid {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  .game-card {
    min-height: 120px;
    padding: 18px;
  }

  .game-title {
    font-size: 15px;
  }

  .game-preview {
    height: 50px;
  }

  .menu-button {
    min-width: 130px;
    font-size: 15px;
    padding: 15px 20px;
    min-height: 56px;
  }
}

/* Landscape mobile optimization */
@media (max-height: 600px) and (orientation: landscape) {
  .main-menu {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    padding: 10px;
  }

  .logo {
    width: 100%;
    font-size: 24px;
    margin-bottom: 15px;
    text-align: center;
  }

  .game-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    max-height: calc(100vh - 120px);
    overflow-y: auto;
  }

  .game-card {
    min-height: 100px;
    padding: 12px;
  }

  .game-title {
    font-size: 13px;
  }

  .game-preview {
    height: 40px;
  }

  .game-highscore {
    font-size: 11px;
  }

  .menu-buttons {
    width: 100%;
    justify-content: center;
    padding: 10px 0;
  }

  .menu-button {
    min-height: 48px;
  }
}

/* Game canvas in landscape - maximize screen usage */
@media (orientation: landscape) {
  #gameCanvas {
    max-width: 100vw;
    max-height: 100vh;
  }
}

/* Orientation Suggestion Overlay */
.orientation-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(64, 49, 141, 0.98);
  display: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  padding: 20px;
  text-align: center;
}

.orientation-overlay.show {
  display: flex;
}

.orientation-icon {
  font-size: 72px;
  margin-bottom: 20px;
  color: var(--c64-cyan);
  animation: rotatePhone 2s ease-in-out infinite;
}

@keyframes rotatePhone {
  0%, 100% { transform: rotate(0deg); }
  50% { transform: rotate(90deg); }
}

.orientation-text {
  font-size: 20px;
  color: var(--c64-white);
  margin-bottom: 10px;
  line-height: 1.4;
}

.orientation-subtext {
  font-size: 14px;
  color: var(--c64-light-grey);
}

/* Utility Classes */
.hidden {
  display: none !important;
}

.loading {
  opacity: 0.5;
  pointer-events: none;
}

.blink {
  animation: blink 1s infinite;
}

@keyframes blink {
  0%, 50% { opacity: 1; }
  51%, 100% { opacity: 0; }
}`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAE7B,wCAAwC;AACxC;EACE,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;EACrB,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,oBAAoB;EACpB,wBAAwB;EACxB,wBAAwB;EACxB,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA,iCAAiC;AACjC;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,qCAAqC;EACrC,iCAAiC;EACjC,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,oCAAoC;EACpC,iCAAiC;EACjC,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE,cAAc;EACd,cAAc;EACd,kCAAkC;EAClC,kCAAkC;EAClC,0CAA0C;EAC1C,oCAAoC;EACpC,iCAAiC;EACjC,+BAA+B;EAC/B,0BAA0B;EAC1B,kBAAkB,EAAE,wCAAwC;EAC5D,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,kCAAkC;EAClC,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,wCAAwC;EACxC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,kCAAkC;EAClC,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,aAAa;AACb;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,4BAA4B;EAC5B,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,kCAAkC;EAClC,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,MAAM;EACN,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,uBAAuB;EACvB,kCAAkC;EAClC,oBAAoB;EACpB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,sBAAsB;AACtB;EACE;IACE,8BAA8B,EAAE,gCAAgC;EAClE;;EAEA;IACE,YAAY;IACZ,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,aAAa;IACb,gBAAgB;IAChB,iCAAiC,EAAE,4BAA4B;EACjE;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,UAAU;IACV,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB,EAAE,wBAAwB;EAC5C;;EAEA;IACE,aAAa;EACf;;EAEA,yCAAyC;EACzC;IACE,uBAAuB,EAAE,qDAAqD;IAC9E,oBAAoB;IACpB,kBAAkB,EAAE,oCAAoC;IACxD,0BAA0B,EAAE,6BAA6B;IACzD,UAAU;IACV,0BAA0B;IAC1B,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,qCAAqC;IACrC,SAAS;IACT,+BAA+B;IAC/B,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,qDAAqD;AACrD;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA,mCAAmC;AACnC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,mCAAmC;EACnC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,WAAW,uBAAuB,EAAE;EACpC,MAAM,wBAAwB,EAAE;AAClC;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA,oBAAoB;AACpB;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,UAAU,UAAU,EAAE;EACtB,YAAY,UAAU,EAAE;AAC1B","sourcesContent":["/* C64 Arcade - Main Styles */\n\n/* CSS Variables for C64 Color Palette */\n:root {\n  --c64-black: #000000;\n  --c64-white: #FFFFFF;\n  --c64-red: #883932;\n  --c64-cyan: #67B6BD;\n  --c64-purple: #8B3F96;\n  --c64-green: #55A049;\n  --c64-blue: #40318D;\n  --c64-yellow: #BFCE72;\n  --c64-orange: #8B5429;\n  --c64-brown: #574200;\n  --c64-light-red: #B86962;\n  --c64-dark-grey: #505050;\n  --c64-medium-grey: #787878;\n  --c64-light-green: #94E089;\n  --c64-light-blue: #7869C4;\n  --c64-light-grey: #9F9F9F;\n}\n\n/* Global Reset and Base Styles */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml, body {\n  height: 100%;\n  font-family: 'Courier New', monospace;\n  background-color: var(--c64-blue);\n  color: var(--c64-white);\n  overflow: hidden;\n  user-select: none;\n  -webkit-user-select: none;\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: transparent;\n}\n\n#app {\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\n/* Pixel Art Font */\n.pixel-font {\n  font-family: 'Courier New', monospace;\n  image-rendering: -webkit-optimize-contrast;\n  image-rendering: -webkit-crisp-edges;\n  image-rendering: -moz-crisp-edges;\n  image-rendering: -o-crisp-edges;\n  image-rendering: pixelated;\n}\n\n/* Main Game Canvas */\n#gameCanvas {\n  display: block;\n  margin: 0 auto;\n  background-color: var(--c64-black);\n  border: 2px solid var(--c64-white);\n  image-rendering: -webkit-optimize-contrast;\n  image-rendering: -webkit-crisp-edges;\n  image-rendering: -moz-crisp-edges;\n  image-rendering: -o-crisp-edges;\n  image-rendering: pixelated;\n  touch-action: none; /* Prevent all default touch behaviors */\n  max-width: 100vw;\n  max-height: 100vh;\n  -webkit-user-select: none;\n  user-select: none;\n}\n\n/* UI Container */\n.ui-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  z-index: 10;\n}\n\n.ui-container > * {\n  pointer-events: auto;\n}\n\n/* Main Menu Styles */\n.main-menu {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n  padding: 20px;\n}\n\n.logo {\n  font-size: 48px;\n  font-weight: bold;\n  color: var(--c64-cyan);\n  text-align: center;\n  margin-bottom: 40px;\n  line-height: 1;\n  text-shadow: 2px 2px 0px var(--c64-blue);\n}\n\n.game-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n  max-width: 900px;\n  width: 100%;\n  margin-bottom: 30px;\n}\n\n.game-card {\n  background: var(--c64-black);\n  border: 3px solid var(--c64-white);\n  padding: 15px;\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.1s;\n  min-height: 140px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.game-card:hover {\n  background: var(--c64-white);\n  color: var(--c64-black);\n  border-color: var(--c64-cyan);\n}\n\n.game-card:active {\n  transform: scale(0.95);\n}\n\n.game-title {\n  font-size: 14px;\n  font-weight: bold;\n  margin-bottom: 10px;\n}\n\n.game-preview {\n  height: 60px;\n  background: var(--c64-blue);\n  border: 1px solid var(--c64-medium-grey);\n  margin-bottom: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n}\n\n.game-highscore {\n  font-size: 12px;\n  color: var(--c64-yellow);\n}\n\n.menu-buttons {\n  display: flex;\n  gap: 20px;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.menu-button {\n  background: var(--c64-green);\n  color: var(--c64-white);\n  border: 2px solid var(--c64-white);\n  padding: 10px 20px;\n  font-family: inherit;\n  font-size: 14px;\n  cursor: pointer;\n  transition: all 0.1s;\n  min-width: 120px;\n}\n\n.menu-button:hover {\n  background: var(--c64-light-green);\n  color: var(--c64-black);\n}\n\n.menu-button:active {\n  transform: scale(0.95);\n}\n\n/* Game HUD */\n.game-hud {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 40px;\n  background: var(--c64-black);\n  border-bottom: 2px solid var(--c64-white);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0 20px;\n  font-size: 14px;\n  z-index: 20;\n}\n\n.hud-left, .hud-right {\n  display: flex;\n  gap: 20px;\n}\n\n.hud-center {\n  font-weight: bold;\n  color: var(--c64-yellow);\n}\n\n/* Mobile Controls */\n.mobile-controls {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 120px;\n  background: rgba(0, 0, 0, 0.8);\n  display: none;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px;\n  z-index: 30;\n}\n\n.virtual-dpad {\n  width: 80px;\n  height: 80px;\n  position: relative;\n  background: var(--c64-dark-grey);\n  border: 2px solid var(--c64-white);\n  border-radius: 50%;\n}\n\n.dpad-button {\n  position: absolute;\n  background: var(--c64-medium-grey);\n  border: 1px solid var(--c64-white);\n  color: var(--c64-white);\n  font-weight: bold;\n  cursor: pointer;\n  user-select: none;\n}\n\n.dpad-up {\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 24px;\n  height: 24px;\n  line-height: 22px;\n  text-align: center;\n}\n\n.dpad-down {\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 24px;\n  height: 24px;\n  line-height: 22px;\n  text-align: center;\n}\n\n.dpad-left {\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 24px;\n  height: 24px;\n  line-height: 22px;\n  text-align: center;\n}\n\n.dpad-right {\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 24px;\n  height: 24px;\n  line-height: 22px;\n  text-align: center;\n}\n\n.action-buttons {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.action-button {\n  width: 60px;\n  height: 30px;\n  background: var(--c64-red);\n  color: var(--c64-white);\n  border: 2px solid var(--c64-white);\n  font-family: inherit;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.action-button:active {\n  background: var(--c64-light-red);\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  body {\n    -webkit-text-size-adjust: none; /* Prevent text scaling on iOS */\n  }\n\n  #app {\n    width: 100vw;\n    height: 100vh;\n    overflow: hidden;\n  }\n\n  .main-menu {\n    padding: 15px;\n    height: 100vh;\n    overflow-y: auto;\n    -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */\n  }\n\n  .logo {\n    font-size: 36px;\n    margin-bottom: 30px;\n    padding: 10px 0;\n  }\n\n  .game-grid {\n    grid-template-columns: 1fr;\n    gap: 15px;\n    padding: 0;\n    max-width: 100%;\n    margin-bottom: 20px;\n  }\n\n  .game-card {\n    min-height: 120px;\n    padding: 20px;\n    border-width: 3px;\n  }\n\n  .game-title {\n    font-size: 16px;\n    margin-bottom: 12px;\n  }\n\n  .game-preview {\n    height: 50px;\n    font-size: 24px;\n    margin-bottom: 12px;\n  }\n\n  .game-highscore {\n    font-size: 13px;\n  }\n\n  .menu-buttons {\n    gap: 15px;\n    padding: 15px 0;\n  }\n\n  .menu-button {\n    min-width: 140px;\n    padding: 16px 24px;\n    font-size: 16px;\n    min-height: 56px; /* Larger touch target */\n  }\n\n  .mobile-controls {\n    display: flex;\n  }\n\n  /* Improve canvas positioning on mobile */\n  #gameCanvas {\n    border: none !important; /* Remove border on mobile for maximum screen usage */\n    margin: 0 !important;\n    touch-action: none; /* Prevent default touch behaviors */\n    position: fixed !important; /* Ensure it stays in place */\n    z-index: 1;\n    max-width: none !important;\n    max-height: none !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .main-menu {\n    padding: 10px;\n  }\n\n  .logo {\n    font-size: 32px;\n    margin-bottom: 25px;\n  }\n\n  .game-grid {\n    grid-template-columns: 1fr;\n    gap: 15px;\n  }\n\n  .game-card {\n    min-height: 120px;\n    padding: 18px;\n  }\n\n  .game-title {\n    font-size: 15px;\n  }\n\n  .game-preview {\n    height: 50px;\n  }\n\n  .menu-button {\n    min-width: 130px;\n    font-size: 15px;\n    padding: 15px 20px;\n    min-height: 56px;\n  }\n}\n\n/* Landscape mobile optimization */\n@media (max-height: 600px) and (orientation: landscape) {\n  .main-menu {\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: center;\n    padding: 10px;\n  }\n\n  .logo {\n    width: 100%;\n    font-size: 24px;\n    margin-bottom: 15px;\n    text-align: center;\n  }\n\n  .game-grid {\n    grid-template-columns: repeat(3, 1fr);\n    gap: 10px;\n    max-height: calc(100vh - 120px);\n    overflow-y: auto;\n  }\n\n  .game-card {\n    min-height: 100px;\n    padding: 12px;\n  }\n\n  .game-title {\n    font-size: 13px;\n  }\n\n  .game-preview {\n    height: 40px;\n  }\n\n  .game-highscore {\n    font-size: 11px;\n  }\n\n  .menu-buttons {\n    width: 100%;\n    justify-content: center;\n    padding: 10px 0;\n  }\n\n  .menu-button {\n    min-height: 48px;\n  }\n}\n\n/* Game canvas in landscape - maximize screen usage */\n@media (orientation: landscape) {\n  #gameCanvas {\n    max-width: 100vw;\n    max-height: 100vh;\n  }\n}\n\n/* Orientation Suggestion Overlay */\n.orientation-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(64, 49, 141, 0.98);\n  display: none;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  z-index: 9999;\n  padding: 20px;\n  text-align: center;\n}\n\n.orientation-overlay.show {\n  display: flex;\n}\n\n.orientation-icon {\n  font-size: 72px;\n  margin-bottom: 20px;\n  color: var(--c64-cyan);\n  animation: rotatePhone 2s ease-in-out infinite;\n}\n\n@keyframes rotatePhone {\n  0%, 100% { transform: rotate(0deg); }\n  50% { transform: rotate(90deg); }\n}\n\n.orientation-text {\n  font-size: 20px;\n  color: var(--c64-white);\n  margin-bottom: 10px;\n  line-height: 1.4;\n}\n\n.orientation-subtext {\n  font-size: 14px;\n  color: var(--c64-light-grey);\n}\n\n/* Utility Classes */\n.hidden {\n  display: none !important;\n}\n\n.loading {\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n.blink {\n  animation: blink 1s infinite;\n}\n\n@keyframes blink {\n  0%, 50% { opacity: 1; }\n  51%, 100% { opacity: 0; }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
